import React, { Component } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { getFuelVoucherByItinerary } from '../../../../actions';
import { printFuelVoucher } from '../../../../utils/printers/FuelVoucher';
import withEndpointAuthorization from '../../authorization/withEndPointAuthorization';
import { generateGetPreviewFuelVoucherEndpoint } from '../../../../config/endpoints';
import { GET } from '../../../../config/permissions';

class ReprintFuelVoucherButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  printFuelVoucher = async () => {
    const { itinerary, dispatchGetFuelVocuherByItinerary } = this.props;

    const fuelVouchers = await dispatchGetFuelVocuherByItinerary({
      itineraryId: itinerary.get('id'),
    });

    if (fuelVouchers) {
      printFuelVoucher(fuelVouchers);
    }
  };

  render() {
    const { loading } = this.state;

    const loadingIcon = loading ? (
      <i className="fa fa-spinner fa-spin fa-fw" />
    ) : (
      <i className="fa fa-print" />
    );

    return (
      <>
        <Button color="light" className="border" onClick={this.printFuelVoucher}>
          {loadingIcon} Guardar Vales de Combustible
        </Button>
      </>
    );
  }
}

ReprintFuelVoucherButton.propTypes = {
  itinerary: PropTypes.instanceOf(Immutable.Map).isRequired,
  dispatchGetFuelVocuherByItinerary: PropTypes.func.isRequired,
};

const mapStateToProps = ({ ItineraryUnit }) => ({
  itinerary: ItineraryUnit.Itinerary.getIn(['current', 'content']),
});

const mapDispatchToProps = {
  dispatchGetFuelVocuherByItinerary: getFuelVoucherByItinerary,
};

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReprintFuelVoucherButton);

export default withEndpointAuthorization({
  url: generateGetPreviewFuelVoucherEndpoint(0),
  permissionType: GET,
})(connectedComponent);
